import { Button, Badge } from '@mui/material';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../contexts/auth';
import { useMenuContext } from '../../../contexts/menuContextProvider';
import React, { useEffect, useState } from 'react';
import { getVideoCountByCategory } from '../../../api/video';

export default function VideoKategoriaMenuButton({ kategoriaNev, katKey }) {
  const navigate = useNavigate();
  const { setMenu } = useMenuContext();
  const { user } = useAuth();
  const [videoCount, setVideoCount] = useState(0);

  function openCategory(e) {
    setMenu({ type: 'cat', key: katKey, title: kategoriaNev });

    if (user) {
      navigate('/videos');
    } else {
      navigate('/login');
    }
  }

  useEffect(() => {
    getVideoCountByCategory(katKey, new Date('2020.01.01')).then((res) => {
      setVideoCount(res?.data?.videoCount || 0); // biztosítjuk hogy szám legyen
    });
  }, []);

  return (
    <Badge
      badgeContent={videoCount}
      color='error'
      invisible={videoCount === 0}
      overlap='circular'
      sx={{ mx: 1, maxWidth: '100px' }}
    >
      <Button
        key={katKey}
        color='inherit'
        sx={{
          flex: '1 1 auto',
          minWidth: '60px',
          textAlign: 'center',
        }}
        onClick={() => openCategory()}
      >
        {kategoriaNev}
      </Button>
    </Badge>
  );
}
